import { render } from "./Page-Title.vue?vue&type=template&id=275a5518&scoped=true"
import script from "./Page-Title.vue?vue&type=script&lang=js"
export * from "./Page-Title.vue?vue&type=script&lang=js"

import "./Page-Title.vue?vue&type=style&index=0&id=275a5518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275a5518"]])

export default __exports__